/**
 * RemarkAnnotationEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { RemarkEntity } from "../RemarkEntity";
import { RemarkAnnotationEntity } from "../RemarkAnnotationEntity";
declare global {
    interface EntityTypeMap {
        RemarkAnnotation: RemarkAnnotationEntity;
    }
}
export abstract class RemarkAnnotationGeneratedEntity extends BaseEntity {
    public abstract templateId: string | null;
    public abstract creationDate: Date;
    public abstract hasMetadata: boolean;
    public abstract drawingHint: number;
    public abstract temp: boolean;
    public abstract remarkAnnotationId: string;
    public abstract remark: RemarkEntity;
    public abstract parentAnnotatedEntity: RemarkEntity;
}
